import styled from 'styled-components';
import MinimizeButton from './minimize-btn/MinimizeBtn';

export const MinimizeBtn = styled(MinimizeButton)`
  @media (hover: hover) {
    opacity: 0;
    transition: all 0.2s;
  }
`;

export const PlayerWrapper = styled.div`
  position: fixed;
  width: 180px;
  padding-top: ${props => (props.minimized ? '0.8rem' : '2rem')};
  padding-bottom: ${props => (props.minimized ? '0.8rem' : '2rem')};
  bottom: 0;
  background-color: #f7f7f7;
  width: 100%;
  box-shadow: 0px 3px 10px 0 rgba(0, 0, 0, 0.2);
  z-index: 11;
  &:hover {
    ${MinimizeBtn} {
      opacity: 1;
    }
  }
`;

export const ControlWrapper = styled.div`
  display: grid;
  grid-template-columns: auto 1fr 31px auto;
  grid-gap: 30px;
  align-items: center;
  @media (max-width: 800px) {
    grid-template-columns: 1fr 31px auto auto 1fr;
    margin-top: 3rem;
    &:first-child {
      grid-column: 3/4;
    }
  }
`;

export const Progress = styled.progress`
  -webkit-appearance: none;
  appearance: none;
  display: block;
  background: #e1e1e1;
  border-radius: 20px;
  width: 100%;
  height: 5px;
  position: absolute;
`;

export const Range = styled.input`
  position: absolute;
  z-index: 2;
  width: 100%;
  cursor: pointer;
  opacity: 0;
  -webkit-tap-highlight-color: transparent;
`;

export const ProgressWrapper = styled.div`
  display: grid;
  grid-gap: 3rem;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  .duration {
    font-size: 14px;
  }

  @media (max-width: 800px) {
    grid-column: 1/-1;
    grid-row: 2/3;
  }
`;

export const ProgressBar = styled.div`
  position: relative;

  progress::-webkit-progress-bar {
    background: transparent;
  }

  progress::-moz-progress-bar {
    border-radius: 20px;
    background: #e1e1e1;
  }

  progress::-webkit-progress-value {
    border-radius: 10px;
    background: #f9703e;
  }

  progress::-webkit-slider-thumb {
    width: 40px;
    height: 20px;
  }
`;
